import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

class TilesWithModal extends HTMLElement {
  /** @type {number} */
  #selectedIndex = 0;
  /** @type {string | undefined} */
  #modalId;
  /** @type {string | undefined} */
  #slideChangeEvent;
  /** @type {boolean} */
  #modalPanelsInited = false;

  connectedCallback() {
    this.#modalId = this.dataset.modalId;
    if (!this.#modalId) return;

    this.#handleCardClicks();
    this.#handleModalOpen();
    this.#slideChangeEvent = `tiles-modal:slide-change:${this.#modalId}`;
    PubSub.subscribe(this.#slideChangeEvent, (options) => this.#onSlideChange(options));
  }

  #initModalPanels() {
    const modal = document.getElementById(this.#modalId);
    if (!modal || this.#modalPanelsInited) return;

    const slides = modal.querySelectorAll('.tiles-modal__pane');
    if (!slides.length) return;

    modal
      ?.querySelector('.tiles-modal__nav')
      ?.addEventListener('click', (event) => this.#onNavClick(event));

    this.#modalPanelsInited = true;
  }

  /** @param {MouseEvent} event */
  #onNavClick(event) {
    const modal = document.getElementById(this.#modalId);
    if (!modal) return;

    const slides = modal.querySelectorAll('.tiles-modal__pane');
    const prevBtn = event.target.closest('.embla-button--prev');

    if (prevBtn && prevBtn.getAttribute('aria-disabled') !== 'true') {
      event.preventDefault();
      const index = Math.max(0, this.#selectedIndex - 1);
      this.#selectedIndex = index;
      this.#showModalSlide(index);
      this.#dispatchSlideChange();
      this.#updateNavButtons(modal, index, slides.length);
      return;
    }

    const nextBtn = event.target.closest('.embla-button--next');
    if (nextBtn && nextBtn.getAttribute('aria-disabled') !== 'true') {
      event.preventDefault();
      const index = Math.min(slides.length - 1, this.#selectedIndex + 1);
      this.#selectedIndex = index;
      this.#showModalSlide(index);
      this.#dispatchSlideChange();
      this.#updateNavButtons(modal, index, slides.length);
    }
  }

  #showModalSlide(index) {
    const modal = document.getElementById(this.#modalId);
    if (!modal) return;

    const slides = modal.querySelectorAll('.tiles-modal__pane');
    slides.forEach((slide, i) => {
      slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });
  }

  #updateNavButtons(modal, index, total) {
    const prevBtn = modal.querySelector('.tiles-modal__nav .embla-button--prev');
    const nextBtn = modal.querySelector('.tiles-modal__nav .embla-button--next');
    if (!prevBtn && !nextBtn) return;
    if (prevBtn) {
      prevBtn.classList.toggle('embla__button--disabled', index <= 0);
      prevBtn.setAttribute('aria-disabled', index <= 0 ? 'true' : 'false');
    }
    if (nextBtn) {
      nextBtn.classList.toggle('embla__button--disabled', index >= total - 1);
      nextBtn.setAttribute('aria-disabled', index >= total - 1 ? 'true' : 'false');
    }
  }

  #handleCardClicks() {
    this.addEventListener('click', (event) => {
      const card = event.target.closest('[data-tiles-card]');
      if (!card) return;

      const blockId = card.getAttribute('data-block-id');
      if (!blockId) return;

      const modal = document.getElementById(this.#modalId);
      if (!modal) return;

      const slides = modal.querySelectorAll('.tiles-modal__pane[data-block-id]');
      let index = 0;
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-block-id') === blockId) {
          index = i;
          break;
        }
      }

      this.#selectedIndex = index;
      event.preventDefault();
      PubSub.publish('dialog:open', { id: this.#modalId });
    });
  }

  #handleModalOpen() {
    PubSub.subscribe('dialog:open', ({ id }) => {
      if (id !== this.#modalId) return;

      this.#initModalPanels();

      requestAnimationFrame(() => {
        this.#showModalSlide(this.#selectedIndex);
        this.#dispatchSlideChange();

        const modal = document.getElementById(this.#modalId);
        if (!modal) return;
        const slides = modal.querySelectorAll('.tiles-modal__pane');
        this.#updateNavButtons(modal, this.#selectedIndex, slides.length);
      });
    });
  }

  #dispatchSlideChange() {
    const modal = document.getElementById(this.#modalId);
    if (!modal) return;

    const slides = modal.querySelectorAll('.tiles-modal__pane');
    const index = this.#selectedIndex;
    const total = slides.length;
    const slide = slides[index];
    const heading = slide ? slide.getAttribute('data-heading') || '' : '';

    PubSub.publish(this.#slideChangeEvent, { index, total, heading });
  }

  #onSlideChange(options) {
    if (!options) return;

    const { index, total, heading } = options;
    const modal = document.getElementById(this.#modalId);
    if (!modal) return;

    const titleEl = modal.querySelector('[data-tiles-modal-title]');
    if (titleEl) titleEl.textContent = heading;

    const currentEl = modal.querySelector('[data-tiles-modal-current]');
    const totalEl = modal.querySelector('[data-tiles-modal-total]');
    if (currentEl) currentEl.textContent = String(index + 1);
    if (totalEl) totalEl.textContent = String(total);
  }
}

customElements.define('tiles-with-modal', TilesWithModal);
